<template>
	<q-card
		:class="isMobile ? 'bg-black q-pt-md' : 'bg-white'"
		:style="isMobile ? '' : 'min-width: 80vw; min-height: 50vh; max-height: 80vh;'"
	>
		<q-toolbar :class="isMobile ? 'text-white q-px-md' : ''">
			<q-toolbar-title>{{ $t('certificates') }}</q-toolbar-title>

			<q-btn @click="close_modal" flat round dense icon="fal fa-times" v-close-popup />
		</q-toolbar>

		<q-card-section>
			<div :class="isMobile ? 'bg-black' : 'bg-white'">
				<q-tabs
					v-model="tab"
					align="justify"
					:class="isMobile ? 'bg-black text-white' : 'bg-white'"
					:active-bg-color="isMobile ? 'bg-black' : 'bg-white'"
					:indicator-color="isMobile ? 'white' : 'black'"
					@update:model-value="changeTab()"
				>
					<q-tab v-if="hasCourses" name="group_trainings" :label="$t(titleCourses)" />
					<q-tab v-if="hasTrails" name="trails" :label="$t(titleTrails)" />
					<q-tab v-if="hasPresentials" name="presential_events" :label="$t(titlePresentials)" />
					<q-tab v-if="hasLiveClasses" name="live_classes" :label="$t(titleLiveClasses)" />
					<q-tab v-if="hasWebinars" name="webcasts" :label="$t(titleWebinars)" />
				</q-tabs>
			</div>

			<div v-if="certificates?.length" class="q-mt-md">
				<div class="row q-col-gutter-lg">
					<div class="col-sm-4 col-xs-12" v-for="(certificate, index) in certificates" :key="index">
						<q-card
							:dark="isMobile"
							class="full-height cursor-pointer"
							@click="$emit('showCertificate', certificate)"
						>
							<q-img style="width: 100%" :src="certificateImage(certificate)" />

							<q-card-section>
								<div class="text-h6">{{ certificate.title }}</div>
								<div class="text-body2">{{ $dateUtil.fDateTime(certificate.result_date) }}</div>
							</q-card-section>
						</q-card>
					</div>
				</div>
			</div>
			<q-item
				v-if="!loading && certificates?.length === 0"
				:class="isMobile ? 'text-white' : 'text-grey-9'"
			>
				<q-item-section class="text-body1">
					{{ $t('you_dont_have_certificates_in_this_category') }}
				</q-item-section>
			</q-item>
		</q-card-section>
	</q-card>
</template>

<script setup>
import { axios } from 'boot/axios'
import { ref, computed, onMounted, defineProps, getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import { useQuasar } from 'quasar'

const props = defineProps({
	close_modal: Function,
	hasCourses: Boolean,
	hasTrails: Boolean,
	hasPresentials: Boolean,
	hasLiveClasses: Boolean,
	hasWebinars: Boolean,
	titleCourses: String,
	titleTrails: String,
	titlePresentials: String,
	titleLiveClasses: String,
	titleWebinars: String,
})

const store = useStore()
const $q = useQuasar()
const { ctx } = getCurrentInstance()

const id_user_client_selected = store.getters['common/id_user_client_selected']
const clients = store.getters['params/clients']

const isMobile = computed(() => $q.platform.is.mobile)

const loading = ref(false)
// const skeletons = ref([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10])
const tab = ref('group_trainings')
const certificates = ref([])

const getUserCertificates = async () => {
	$q.loading.show()
	loading.value = true
	certificates.value = []

	try {
		const response = await axios.get(`etraining_profile/my_profile/user_results/?type=${tab.value}`)
		if (!response.data?.[tab.value]) {
			return
		}

		certificates.value = response.data[tab.value]
			.map((e) => {
				return tab.value === 'group_trainings'
					? {
							...e,
							origin: 'group_trainings',
							images: e.group_training_images.map((f) => ({ ...f, image: f.image_url })),
							title: e.group_training_title,
					  }
					: tab.value === 'trails'
					? {
							...e,
							origin: 'trails',
							images: e.trail_images,
							title: e.trail_title,
					  }
					: tab.value === 'presential_events'
					? {
							...e,
							origin: 'presential_events',
							images: e.presential_event_images,
							title: e.presential_event_title,
					  }
					: tab.value === 'live_classes'
					? {
							...e,
							origin: 'live_classes',
							images: e.live_class_images,
							title: e.live_class_title,
					  }
					: tab.value === 'webcasts'
					? {
							...e,
							origin: 'webcasts',
							images: e.webcast_images,
							title: e.webcast_title,
					  }
					: {}
			})
			.sort((a, b) => new Date(a.result_date) - new Date(b.result_date))
			.reverse()
	} catch (e) {
		console.log(e)
		$q.notify({
			message: ctx.$t('an_unexpected_error_has_occurred_try_again'),
			type: 'negative',
			icon: 'fal fa-exclamation-triangle',
			position: 'bottom',
		})
	} finally {
		loading.value = false
		$q.loading.hide()
	}
}

const certificateImage = (obj) => {
	const image = obj.images.find((e) => e.name === 'original')

	const client = clients.find((clt) => clt.id == id_user_client_selected)
	if (image.image_url || image.image) {
		if (image.image_url) return image.image_url
		else if (image.image) return image.image
	} else {
		if (obj.origin === 'group_trainings') return client.group_training_placeholder
		else return client.webcast_placeholder
	}
}

const changeTab = () => {
	certificates.value = []
	getUserCertificates()
}

onMounted(() => {
	if (!props.hasCourses) {
		props.hasPresentials
			? (tab.value = 'presential_events')
			: props.hasLiveClasses
			? (tab.value = 'live_classes')
			: (tab.value = 'podcasts')
	}
	getUserCertificates()
})
</script>
